module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.defaultImage >= 0) ? _c('basic-slider', {
    attrs: {
      "images": _vm.listOfImages,
      "default": _vm.defaultImage,
      "nextButton": this.titleNext,
      "previousButton": this.titlePrevious
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fabb4b50!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/_partials/images.vue
// module id = 273
// module chunks = 1